import React, {Component} from 'react'
import { Route, Link } from 'react-router-dom';
import { Menu, Icon, Layout } from 'antd';
import Nav from '@/components/Nav';
import AgentInfo from '@/components/AgentManage/AgentInfo'
import CustomerList from '@/components/AgentManage/CustomerList'
import ConsumeRecord from '@/components/AgentManage/ConsumeRecord'
import OpenBusiness from '@/components/AgentManage/OpenBusiness'
import './style.less';

const { Sider, Content } = Layout;
const clsPrefix = "AgentPage";

const SubMenu = Menu.SubMenu;

class AgentPage extends Component {

    rootSubmenuKeys = ["account"];

    constructor(pros) {
        super(pros);
        this.state = {
            openKeys: ["account", "customer"]
        };
    }

    onOpenChange = (openKeys) => {
        const latestOpenKey = openKeys.find(key => this.state.openKeys.indexOf(key) === -1);
        if (this.rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
            this.setState({ openKeys });
        } else {
            this.setState({
                openKeys: latestOpenKey ? [latestOpenKey] : [],
            });
        }
    };

    render() {
        return (
            <React.Fragment>
                <Nav />
                <Layout style={{ maxHeight: "0" }}>
                    <Sider className={`${clsPrefix}-sider`}>
                        <Menu
                            mode="inline"
                            openKeys={this.state.openKeys}
                            onOpenChange={this.onOpenChange}
                        >
                            <SubMenu key="account" title={<span><Icon type="mail" /><span>账户管理</span></span>}>
                                <Menu.Item key="1">
                                    <Link to={this.props.match.url}>账户信息</Link>
                                </Menu.Item>
                            </SubMenu>
                            <SubMenu key="customer" title={<span><Icon type="appstore" /><span>客户管理</span></span>}>
                                <Menu.Item key="2">
                                    <Link to={`${this.props.match.url}/customerList`}>客户列表</Link>
                                </Menu.Item>
                                <Menu.Item key="3">
                                    <Link to={`${this.props.match.url}/consumeRecord`}>客户消费记录</Link>
                                </Menu.Item>
                                <Menu.Item key="4">
                                    <Link to={`${this.props.match.url}/openBusiness`}>套餐开通</Link>
                                </Menu.Item>
                            </SubMenu>
                        </Menu>
                    </Sider>
                    <Content className={`${clsPrefix}-content`}>
                        <AgentContentPage match={this.props.match} />
                    </Content>
                </Layout>
            </React.Fragment>
        );
    }
}

// TODO: 疑问, 对象外面的{}和 jsx 外面的()
const AgentContentPage = ({ match }) => (
    <div>
        <Route exact path={`${match.url}`} component={AgentInfo} />
        <Route path={`${match.url}/customerList`} component={CustomerList} />
        <Route path={`${match.url}/consumeRecord`} component={ConsumeRecord} />
        <Route path={`${match.url}/openBusiness`} component={OpenBusiness} />
    </div>
);

export default AgentPage;